var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"cell-sortable",on:{"click":_vm.cellSort}},[_vm._v(_vm._s(_vm.label)),_c('span',{staticClass:"caret-wrapper"},[_c('i',{class:['sort-caret', 'ascending', {active: _vm.order===`${_vm.prop}_ascending`}]}),_c('i',{class:['sort-caret', 'descending', {active: _vm.order===`${_vm.prop}_descending`}]})])])
}
var staticRenderFns = []

export { render, staticRenderFns }